import { GetPendingWorkResponse } from "@syla/shared/types/responses/GetPendingWorkResponse";
import axios from "axios";

export const getPendingWork = async (): Promise<GetPendingWorkResponse> => {
  return (await axios.get("/status/pendingWork")).data;
};
